import type { ReactNode } from 'react';

export const symbol_settings_accessibility: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M428.5-835.5Q407-857 407-887t21.5-51.5Q450-960 480-960t51.5 21.5Q553-917 553-887t-21.5 51.5Q510-814 480-814t-51.5-21.5ZM376-230v-464q-54-5-108-12t-104-18q-14-3-21.5-14t-4.5-24q3-14 15.5-19.5T180-784q72 16 148 23t152 7q76 0 152-7t148-23q14-3 27 2.5t16 19.5q3 13-5 24t-22 14q-50 11-104 18t-108 12v464q0 13-8.5 21.5T554-200q-13 0-21.5-8.5T524-230v-214h-88v214q0 13-8.5 21.5T406-200q-13 0-21.5-8.5T376-230ZM289.5-10.5Q279-21 279-38t10.5-27.5Q300-76 317-76t27.5 10.5Q355-55 355-38t-10.5 27.5Q334 0 317 0t-27.5-10.5Zm164 0Q443-21 443-38t10.5-27.5Q464-76 481-76t27.5 10.5Q519-55 519-38t-10.5 27.5Q498 0 481 0t-27.5-10.5Zm164 0Q607-21 607-38t10.5-27.5Q628-76 645-76t27.5 10.5Q683-55 683-38t-10.5 27.5Q662 0 645 0t-27.5-10.5Z"
		/>
	</svg>
);
